import { render, staticRenderFns } from "./CustomerRegisterForm.vue?vue&type=template&id=380ba10e"
import script from "./CustomerRegisterForm.vue?vue&type=script&lang=js"
export * from "./CustomerRegisterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports